export enum GoogleOptimizeDataLayer {
  HAS_EVER_LOGGED_IN = 'hasEverLoggedIn',
  LANGUAGE = 'language',
  COUNTRY_CODE = 'countryCode',
  CITY_CANONICAL = 'cityCanonical',
}
